/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import FuiCalendar, { type Signature as FuiCalendarSig } from './fui-calendar';

export interface Signature {
  Args: Pick<FuiCalendarSig['Args'], 'selected' | 'disabled' | 'isReadOnly'> & {
    propertyName?: string;
    labelName?: string;
    onChange: FuiCalendarSig['Args']['onFocusOut'];
    isMandatory?: boolean;
  };
  Element: HTMLDivElement;
}

const TimePicker: TOC<Signature> = <template>
  {{#if @labelName}}
    <label>
      {{@labelName}}{{if @isMandatory ' *'}}
    </label>
  {{/if}}
  <FuiCalendar
    @selected={{@selected}}
    {{! @glint-expect-error }}
    @settings={{hash type='time' ampm=false}}
    @disabled={{@disabled}}
    @onFocusOut={{@onChange}}
    @isReadOnly={{@isReadOnly}}
    data-test-input={{@propertyName}}
    ...attributes
  />
</template>;

export default TimePicker;
